import { useEffect, useRef } from 'react';
import { useOnlineStatus } from '../hooks/useOnlineStatus';
import { refreshSessionToken } from './tokenRecovery';
import keycloak from './keycloak';

/**
 * Monitors online/offline status and refreshes authentication token
 * when transitioning from offline to online.
 */
export function TokenRefreshMonitor() {
  const isOnline = useOnlineStatus();
  const wasOnlineRef = useRef(isOnline);

  useEffect(() => {
    const wasOnline = wasOnlineRef.current;
    const isNowOnline = isOnline;

    if (!wasOnline && isNowOnline && keycloak.authenticated) {
      void refreshSessionToken().catch(() => undefined);
    }

    wasOnlineRef.current = isNowOnline;
  }, [isOnline]);

  return null;
}
